import { render, staticRenderFns } from "./GlobalFilterNav.vue?vue&type=template&id=94a1d6d2"
import script from "./GlobalFilterNav.vue?vue&type=script&lang=js"
export * from "./GlobalFilterNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94a1d6d2')) {
      api.createRecord('94a1d6d2', component.options)
    } else {
      api.reload('94a1d6d2', component.options)
    }
    module.hot.accept("./GlobalFilterNav.vue?vue&type=template&id=94a1d6d2", function () {
      api.rerender('94a1d6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/global/GlobalFilterNav.vue"
export default component.exports